module.exports = __webpack_public_path__ + "media/end-game-fail.8344f3d3.mp3";